import React from 'react'

const ErrorLabel = ({ children, ...props }) => (
  <p className="font-bold text-sm text-error-text mt-2" {...props}>
    { children }
  </p>
)

export { ErrorLabel }
